// src/utils/textFix.js
//
// Corrección puntual de un texto mal escrito (p. ej. "Julio JARA" → "Julio Lara") en el campo
// "Payable to" de los cheques. Funciones puras: la herramienta de Herramientas las usa para
// mostrar qué cambiaría antes de escribir nada.

const escapeRegExp = text => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Reemplaza todas las apariciones de `find` (sin distinguir mayúsculas) por `replacement`.
// Solo palabras completas: "Julio Jara" no toca "Julio Jaramillo".
export const replaceIgnoreCase = (value, find, replacement) => {
  const needle = String(find || '').trim();
  if (typeof value !== 'string' || !needle) return value;
  const pattern = new RegExp(`(^|[^\\p{L}\\p{N}])${escapeRegExp(needle)}(?![\\p{L}\\p{N}])`, 'giu');
  return value.replace(pattern, (_, before) => `${before}${replacement}`);
};

// Cheques cuyo `payableTo` cambiaría: [{ id, current, next, ... }].
export const payableToFixes = (checks = [], find, replacement) => checks
  .map(check => ({
    id: check.id,
    clientName: check.clientName || '',
    checkNumber: check.checkNumber || '',
    claimNumber: check.claimNumber || '',
    current: check.payableTo || '',
    next: replaceIgnoreCase(check.payableTo || '', find, replacement)
  }))
  .filter(item => item.current && item.next !== item.current);
